/* global window */
/* eslint-disable no-underscore-dangle */

import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { reducer as permissions } from 'react-redux-permissions';

import thunk from 'redux-thunk';
import apiMiddleware from './middleware';
import inspection from '../modules/inspections/redux';
import general from '../general_redux';
import lease from '../modules/Maintenance/redux';
import airfields from '../modules/AirfieldsConditions/components/redux/reducer';
import auth from '../modules/authentication/redux';
import home from '../modules/home/redux';
import invoice from '../modules/invoices/redux';
import document from '../modules/Documents/redux';
import badging from '../modules/Badging/redux';
import gate from '../modules/gate-management/redux';
import trainings from '../modules/Trainings/redux';
import permitManagement from '../modules/PermitManagement/redux';
import smsSafetyPromotion from '../modules/SafetyPromotions/redux';
import updateairport from '../components/topbar/airports/redux';
import profile from '../components/topbar/profile/redux';
import forms from '../modules/forms/redux';
import documents from '../modules/My Documents/redux';
import grossReciepts from '../modules/GrossReciepts/redux';
import tasks from '../modules/tasks/redux';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  combineReducers({
    general,
    airfields,
    inspection,
    permissions,
    lease,
    home,
    auth,
    invoice,
    document,
    badging,
    gate,
    trainings,
    permitManagement,
    smsSafetyPromotion,
    updateairport,
    forms,
    documents,
    grossReciepts,
    tasks,
    profile
  }),
  composeEnhancers(applyMiddleware(apiMiddleware), applyMiddleware(thunk))
);

export default store;
